import React from 'react';
import { useQuery, useMutation } from 'react-fetching-library';
import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
import { Stack, DialogContent, DialogTitle, IconButton, DialogContentText, Portal, Card, CardContent, CardHeader } from '@mui/material';
import { grey } from '@mui/material/colors';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { plPL, GridToolbar } from '@mui/x-data-grid';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';

import { getTransportReportDataAction, getTransportReportAction } from '../../../services/request';
import { transportReportsColumns } from '../../../services/column-definitions';

import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function TransportReportDraggable ({ handleClose }) {
  const apiRef = useGridApiRef();
  const [search, setSearch] = React.useState(null);
  const [height, setHeight] = React.useState(500);
  const [width, setWidth] = React.useState(750);
  const [transports, setTransports] = React.useState([]);
  const [columns, setColumns] = React.useState(transportReportsColumns());

  const { loading, payload, error, query } = useQuery(getTransportReportDataAction(search));
  const { mutate } = useMutation(getTransportReportAction);

  React.useEffect(() => {
    if (!loading && !error) {
      console.log(transports);
      setTransports(payload);
    }
  }, [loading]);

  const handleRefresh = () => {
    query();
  };

  const searchCallback = search => {
    setSearch(search);
  };

  const handleDownload = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutate({ 'data': apiRef.current.getSortedRows() });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Transport.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      alert('Nie udało się pobrać');
    }
  };

  return (
    <Portal>
      <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 99999999, borderRadius: 25 }}>
        <Draggable
          handle="#draggable-dialog-title-transport"
          cancel={'[class*="MuiDialogContent-root"]'}
        >
          <Resizable
            style={{ position: 'absolute' }}
            height={height}
            width={width}
            onResize={(event, data) => {
              setHeight(height + event.movementY);
              setWidth(width + event.movementX);
            }}
          >
            <div style={{ position: 'absolute', borderRadius: 6, overflow: 'hidden', border: '1px solid #00AB55' }}>
              <DialogTitle style={{ cursor: 'move', backgroundColor: 'white', marginTop: 0, paddingTop: '4px', paddingBottom: '4px' }} id="draggable-dialog-title-transport">
                <Stack direction="row" justifyContent="space-between">
                  <Stack direction="row" gap={1}>
                    <IconButton onClick={handleRefresh} >
                      <RefreshIcon />
                    </IconButton>
                    <IconButton onClick={handleDownload}>
                      <FileDownloadIcon />
                    </IconButton>
                  </Stack>

                  <IconButton onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
              </DialogTitle>
              <DialogContent style={{ backgroundColor: grey[50] }}>
                <DialogContentText height={`${height}px`} width={`${width}px`}>
                  <DataGridPro
                    apiRef={apiRef}
                    columns={columns}
                    rows={transports}
                    density="compact"
                    disableColumnMenu={true}
                    autoPageSize={false}
                    autoHeight={true}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    pagination
                    localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                    components={{ Toolbar: DataGridToolbar }}
                    componentsProps={{ toolbar: { containerStyle: { backgroundColor: 'transparent' }, searchStyle: { width: '100%' }, filterToolbar: false, columnsToolbar: false, densityToolbar: false, exportToolbar: false, miniView: true, searchCallback } } }
                    disableSelectionOnClick
                    loading={loading}
                  // onSortModelChange={handleSortModelChange}
                  />
                </DialogContentText>
              </DialogContent>
            </div>
          </Resizable>
        </Draggable>
      </div>
    </Portal>
  );
};
